"use client";
import "./chunk-N3ETBM74.js";
import { InteractionStatus } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
const useAuthStatus = () => {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();
  const ready = inProgress === InteractionStatus.None;
  const status = !ready ? "checking" : isAuthenticated ? "authenticated" : "unauthenticated";
  return { status, inProgress };
};
export {
  useAuthStatus
};
